import { EnumWithDescription, ICustomEnumValue } from "./EnumWithDescription";

export enum FrequencyVarianceEnum {
    All = null,
    UnderFrequency = 0,
    OverFrequency = 1
}

export class FrequencyVarianceEnumClass extends EnumWithDescription<FrequencyVarianceEnum> {
    public readonly enum = FrequencyVarianceEnum;
    public readonly enumName: string = "EmployeesScheduledFilterEnum";
    public readonly enumWithDescriptions: Map<string, ICustomEnumValue<FrequencyVarianceEnum>> = new Map([
        [
            "All",
            {
                value: FrequencyVarianceEnum.All,
                name: "All"
            }
        ],
        [
            "UnderFrequency",
            {
                value: FrequencyVarianceEnum.UnderFrequency,
                name: "Under Frequency"
            }
        ],
        [
            "OverFrequency",
            {
                value: FrequencyVarianceEnum.OverFrequency,
                name: "Over Frequency"
            }
        ]
    ]);
}

export const FrequencyVariance = new FrequencyVarianceEnumClass();
